import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { EcoCreditsRightIcon } from './EcoCreditsRightIcon';
import getLocal from '@/app/utils/getLocal';

const textObj: Record<string, string> = {
    eu: '3× EcoCredits',
    de: 'Dreifache EcoCredits',
    fr: 'Triplez vos EcoCredits',
    it: 'Triplo di EcoCredits',
    es: 'El triple de EcoCredits',
    kr: '2×EcoCredits',
};

export const EuEcoCredits = ({ textStr }: { points?: number; textStr?: string }) => {
    const { locale } = getLocal();

    if (!['eu', 'uk', 'de', 'fr', 'it', 'es', 'kr'].includes(locale)) return <></>;

    return (
        <div className={`${styled.EuEcoCredits}`}>
            <span className="box">
                <EditorImg className="gold" pc="https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710569226938/20230912-103811%201.png" />
                <span className="icon-text">
                    <span className="inner">{textStr || textObj[locale] || textObj.eu}</span>
                </span>
                {/* <span className="icon-text">
                    <span className="inner">El triple de EcoCredits</span>
                </span> */}
            </span>
            <EcoCreditsRightIcon />
        </div>
    );
};
